module.exports = __webpack_public_path__ + "static/media/jbl-live-100.b03ee0c4.jpg";